import React from "react";
import { useFormikContext } from "formik";
import { DateOfBirthFormikFieldProps } from "./types";
import { getNestedValue } from "src/components/Form/helper";
import { DateOfBirthField } from "./DateOfBirthField";

export const DateOfBirthFormikField: React.FC<DateOfBirthFormikFieldProps> = ({
  name,
  error,
  disabled,
  helperText,
  label,
  id,
  rules,
}) => {
  const { setFieldValue, values, errors, setFieldError } = useFormikContext();
  const _error: string | undefined = error || getNestedValue(errors, name);
  const _value: Date | undefined = getNestedValue(values, name);
  const _helperText =
    error || (disabled ? helperText : _error?.toString() || helperText);
  return (
    <DateOfBirthField
      onAccept={(date) => {
        setFieldValue(name, date);
        setFieldError(name, undefined);
      }}
      onDeny={(denied, deniedValue) => {
        setFieldError(name, denied);
        setFieldValue(name, deniedValue);
      }}
      error={_error}
      value={_value}
      helperText={_helperText}
      disabled={disabled}
      id={id || name}
      label={label}
      rules={rules}
    />
  );
};
